import { Link } from 'react-router-dom'
import { siteConfig } from '@content/config'

export default function Header() {
  return (
    <header className="bg-white border-b">
      <div className="container-custom py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/images/p4_light.svg" alt={siteConfig.name} className="h-8" />
          </Link>
          <nav className="flex gap-6">
            {siteConfig.nav.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="text-gray-600 hover:text-gray-900"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  )
}
